import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

// 🖼️ Banner images
// import img1 from "../images/banners/1.jpg";  
// import img2 from "../images/banners/2.jpg";
import img3 from "../images/banners/3.jpg";
import img6 from "../images/banners/6.jpg";
import img7 from "../images/banners/7.png";
import img8 from "../images/banners/8.jpg";
import img9 from "../images/banners/9.jpg";
import img10 from "../images/banners/10.jpg";

const banners = [
  { image: img3 },
  { image: img6 },
  { image: img7 },
  { image: img8 },
  { image: img9 },
  { image: img10 },
];

export default function Banner() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const banner = banners[current];

  return (
    <div className="relative w-full overflow-hidden">
      {/* Container with responsive aspect ratio */}
      <div className="relative w-full" style={{ paddingTop: "35%" }}>
        <AnimatePresence mode="sync">
          <motion.img
            key={current}
            src={banner.image}
            alt={`Banner ${current + 1}`}
            loading="lazy"
            className="absolute top-0 left-0 w-full h-full object-cover"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1, ease: "easeInOut" }}
          />
        </AnimatePresence>

        {/* Dark overlay for button visibility */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

        {/* Explore Vehicles Button (hidden on mobile) */}
        <div className="absolute bottom-6 md:bottom-12 left-1/2 -translate-x-1/2 z-20 hidden md:block">
          <Link
            to="/sales"
            className="bg-[#D71920] hover:bg-[#b01217] text-white px-6 py-3 md:px-10 md:py-4 rounded-full font-semibold text-sm md:text-lg shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-[2px]"
          >
            🚗 Explore Vehicles
          </Link>
        </div>

        {/* Slider Dots (hidden on mobile) */}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-3 z-30 hidden md:flex">
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                index === current
                  ? "bg-[#D71920] scale-125"
                  : "bg-white/50 hover:bg-white/80"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
